/*
 * The layout layer, shown as itself. Every cell is a real <BeBox border="plain">,
 * so the bevel draws the cell bounds and the section needs no CSS of its own.
 */

import { BandDemo } from "./BandDemo";
import { ColumnGridDemo } from "./ColumnGridDemo";
import { KeyLinesDemo } from "./KeyLinesDemo";
import { MeasureDemo } from "./MeasureDemo";
import { TilesDemo } from "./TilesDemo";

export function Layout() {
	return (
		<section id="layout" className="demo-category">
			<h1>Layout</h1>
			<ColumnGridDemo />
			<TilesDemo />
			<MeasureDemo />
			<KeyLinesDemo />
			<BandDemo />
		</section>
	);
}
